import { __extends } from "tslib";
import { IncreaseStreamRetentionPeriodInput } from "../models/index";
import { deserializeAws_json1_1IncreaseStreamRetentionPeriodCommand, serializeAws_json1_1IncreaseStreamRetentionPeriodCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var IncreaseStreamRetentionPeriodCommand = /** @class */ (function (_super) {
    __extends(IncreaseStreamRetentionPeriodCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function IncreaseStreamRetentionPeriodCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    IncreaseStreamRetentionPeriodCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: IncreaseStreamRetentionPeriodInput.filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    IncreaseStreamRetentionPeriodCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1IncreaseStreamRetentionPeriodCommand(input, context);
    };
    IncreaseStreamRetentionPeriodCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1IncreaseStreamRetentionPeriodCommand(output, context);
    };
    return IncreaseStreamRetentionPeriodCommand;
}($Command));
export { IncreaseStreamRetentionPeriodCommand };
//# sourceMappingURL=IncreaseStreamRetentionPeriodCommand.js.map